/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_Header_SearchInputs */



/**
* | output |
* | --- |
* | "Search" |
*
* @param {Layout_Header_SearchInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const layout_header_search = /** @type {((inputs?: Layout_Header_SearchInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_Header_SearchInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Suche")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("搜索")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("搜尋")
	if (locale === "ko") return /** @type {LocalizedString} */ ("검색")
	return /** @type {LocalizedString} */ ("Search")
});